<template>
  <div>
    <BasePage v-slot:default="{ openSubPage }" v-if="showDebug">
      <h6>Home</h6>
      <p>Welcome to the Base Home page</p>
      <!--<v-btn
      @click="openSubPage('SoftTermNacherfassung', 'SoftTermNacherfassung')"
      >Open Sub Page - SoftTermNacherfassung</v-btn
    >
    <v-btn @click="openTimeline(openSubPage)"
      >Open Sub Page - VTimeLineDay</v-btn
    >
    <BasePage v-slot:default="{ openSubPage }">
      <h6>Sub Home</h6>
      <v-btn @click="openTimeline(openSubPage)"
        >Open Sub Page - VTimeLineDay</v-btn
      >
    </BasePage>
    <v-btn @click="showSnackbar('huhu')">open Snackbar</v-btn>
    <v-btn @click="showSnackbar({ text: 'fancy huhu', color: 'purple' })"
      >open fancy Snackbar</v-btn
    >
    <hr />
     <h3>Schau dir mal das Zeitraum Control an</h3>
    <SelectZeitraum v-model="zeitbereich"></SelectZeitraum> {{ zeitbereich.bereich }}: {{ zeitbereich.von.toLocaleDateString() }} - {{ zeitbereich.bis.toLocaleDateString() }}<br />
    <SelectZeitraum v-model="zeitbereichRange" :range="true"></SelectZeitraum> {{ zeitbereichRange.bereich }}: {{ zeitbereichRange.von.toLocaleDateString() }} - {{ zeitbereichRange.bis.toLocaleDateString() }}<br />

    <hr />

    <h3>Test MaskedInput</h3>
 
    <MaskedInput
      mask="#-#"
      label="Test"
      placeholder="Test"
      appendInnerIcon="mdi-calendar"
      autofocus
      required
      errorText="Error"
    />
     <OverWriteModeTextBox />
    <hr />

    <EditDatePicker /> -->

      <!-- <EditFileChoicer label="Datei Auswahl" /> -->
      <h3>
        Stefan:

        3) adresszeile wird immer länger - Azure login.. ist noch Lang
        Dashboard - Submasken - dann steht eine ID in der Adressleiste - wäre auch schön wenn wir das wegbekommen würden

        4) Speichern wird immer doppelt aufgerufen ( nur im localhost - im kompilierten funktioniert es...)
 
        6) im Browser hört er manchmal nicht zum Laden auf...
        
        können wir beim SideMenu setzen - wenn man zB auf Admin wechselt - den
        rootView an Navigation mit übergeben - das ich weiß was die default Site
        ist und ich diese markieren kann
      </h3>


      <div>
        EditComboBox: initStichtag - wird richtig gesetzt - aber bei den props.
        kommt es dann bei EditComboBox nicht an...
      </div>


    </BasePage>
  </div>
</template>

<script lang="ts" setup>
import { showSnackbar } from "@/UIHelper";
import BasePage, { OpenSubPageFunction } from "./BasePage.vue";
import MaskedInput from "@/editor/MaskedInput.vue";

import SelectZeitraum from "@/components/common/SelectZeitraum.vue";
import AUApi from "@/api";
import { reactive, ref } from "vue";
import OverWriteModeTextBox from "@/components/OverWriteModeTextBox.vue";
import EditFileChoicer from "@/editor/EditFileChoicer.vue";

const showDebug = AUApi.Current.getCurrentConfig().debug;

const zeitbereich = ref<APIZeitbereich>(AUApi.Current.zeitbereich);
const zeitbereichRange = ref<APIZeitbereich>(AUApi.Current.zeitbereich);
function openTimeline(openSubPage: OpenSubPageFunction) {
  openSubPage(
    "VTimeLineDay",
    "VTimeLineDay",
    {
      day: new Date(),
    },
    () => {
      console.log("called onLeave");
    }
  );
}
</script>
